<div class="wrap" id="dashboard">
    <h1> Dashboard</h1>
  
    <div class="stat">
      <div class="stat_infos">
  
        <div class="tabs">
          <div (click)="setTab('occupancy-rate')" [ngClass]="{tab_active: tab === 'occupancy-rate', tab_deactive: tab !== 'occupancy-rate' }">Taux d'occupation</div>
          <div (click)="setTab('car-suction-cup')" [ngClass]="{tab_active: tab === 'car-suction-cup', tab_deactive: tab !== 'car-suction-cup' }">Temps dépassé</div>
        </div>
  
        <app-occupancy-rate  *ngIf="tab === 'occupancy-rate'" ></app-occupancy-rate>
        <app-car-suction-cup  *ngIf="tab === 'car-suction-cup'" ></app-car-suction-cup>
        
      </div>
      
    </div>
  
  
    <div class="container">
      <app-smartparking-cameras></app-smartparking-cameras>
    </div>
  
  </div>